<template>
  <div>

    <v-overlay>
      <v-row class="justify-center">
        <v-img
          :src="require('@/assets/HIES.png')"
          max-height="320px"
          max-width="320px"
          alt="logo"
          contain
          class="me-3"
        ></v-img>
      </v-row>
      <v-row class="justify-center">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-row>
      <v-row class="justify-center">
        <p>Please wait..</p>
      </v-row>
    </v-overlay>
  
  </div>
</template>

<script>

export default {
  
  name: "Overlay",


};
</script>



